module.exports = "/_next/static/images/ev-man-charging-ea3ae6ce555cab8d12ca9ec971a16a66.jpg.webp";